import { render, staticRenderFns } from "./TransactionDetailsModal.vue?vue&type=template&id=ac10fac2&scoped=true&"
import script from "./TransactionDetailsModal.vue?vue&type=script&lang=js&"
export * from "./TransactionDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./TransactionDetailsModal.vue?vue&type=style&index=0&id=ac10fac2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac10fac2",
  null
  
)

export default component.exports